import React, { useEffect, useMemo, useState } from "react";
import { Typography } from "@mui/material";
import MUITextField from "../../components/MUITextField/MUITextField";
import useAuthenticationHook from "../../hook/useAuthenticationHook";
import userManagementService from "../../services/UserManagementService";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { ROLES } from "../../config/Roles.config";
import HindusRUsIcon from "../../assets/images/HindusRUsIcon.png";
import MUIButton from "../../components/MUIButton/MUIButton";
import LoadingSplash from "../../assets/animation/loading-animation.gif";
import "./Onboarding.style.css";

const Onboarding = () => {
  const { firebaseProfile, completeOnboarding } = useAuthenticationHook();
  const { showSnackbar } = useSnackbar();
  const [language, setLanguage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowSplash(false), 3500); // 3.5s splash
    return () => clearTimeout(t);
  }, []);

  const languageOptions = useMemo(
    () => [
      { id: "lang-en", value: "English", label: "English" },
      { id: "lang-hi", value: "Hindi", label: "Hindi" },
      { id: "lang-mr", value: "Marathi", label: "Marathi" },
      { id: "lang-gu", value: "Gujarati", label: "Gujarati" },
      { id: "lang-ta", value: "Tamil", label: "Tamil" },
      { id: "lang-kn", value: "Kannada", label: "Kannada" },
    ],
    []
  );

  const handleCreateUser = async () => {
    if (!firebaseProfile?.uid) return;
    if (!language) {
      showSnackbar("Please select your preferred language", "warning");
      return;
    }
    try {
      setSubmitting(true);
      const firstName = (firebaseProfile?.displayName || "")?.split(" ")[0] || "";
      const lastName = (firebaseProfile?.displayName || "")
        ?.split(" ")
        ?.slice(1)
        ?.join(" ") || "";

      const payload = {
        uid: firebaseProfile.uid,
        email: firebaseProfile?.email || null,
        firstName,
        lastName,
        profileImage: firebaseProfile?.photoURL || null,
        preferredLanguage: language,
        role: ROLES.USER,
      };

      const { statusCode } = await userManagementService.createOne(payload);
      if (statusCode !== 201 && statusCode !== 200) {
        showSnackbar("Failed to create user. Please try again.", "error");
        return;
      }

      completeOnboarding(payload);
    } catch (error) {
      showSnackbar("Unable to create user. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (showSplash) {
    return (
      <div className="splash-root">
        <img src={LoadingSplash} alt="Loading..." className="splash-image" />
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card" style={{ paddingTop: 24, paddingBottom: 24 }}>
        <img src={HindusRUsIcon} alt="Hindus R Us" className="login-logo" />

        <Typography variant="h5" className="login-title" align="center">
          Daily quotes, Shloks, and podcasts at your fingertips
        </Typography>
        <Typography variant="body2" align="center" style={{ marginTop: 8, opacity: 0.8 }}>
          Explore a vast collection of Hindu scriptures, teachings, and devotional content.
        </Typography>

        <div style={{ marginTop: 24, width: "100%" }}>
          <Typography variant="subtitle2" gutterBottom>
            Preferred Language
          </Typography>
          <MUITextField
            type="select"
            placeholder="Select Language"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            options={languageOptions}
          />
        </div>

        <div style={{ marginTop: 24, width: "100%" }}>
          <MUIButton
            primary
            onClick={handleCreateUser}
            disabled={submitting}
            isLoadingButton
            isLoading={submitting}
            fullWidth
            children={"Get Started"}
          />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;


